import { useQuery } from '@tanstack/react-query';
import { ILocation } from '@clickersphere/core/entities/ILocation';
import LocationService from '@clickersphere/core/services/LocationService';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const LOCATIONS_QUERY_KEY = 'locations';

export type LocationQueryData = WithQueryStatus<ILocation>;

export function useLocations() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: locations,
    isSuccess: isLocationsSuccess,
    isFetching: isLocationsFetching,
    isLoading: isLocationsLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(LOCATIONS_QUERY_KEY),
    queryFn: async () => {
      const result = await LocationService.getAll();
      return result as LocationQueryData[];
    },
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return {
    locations: locations ?? [],
    isLocationsSuccess,
    isLocationsFetching,
    isLocationsLoading,
  };
}
